import {
	Component,
	OnInit,
	ViewChild,
	TemplateRef,
	Input,
	Output,
	EventEmitter,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from 'src/app/services/common/common.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { StorageService } from 'src/app/services/storage/storage.service';

import * as ApexCharts from 'apexcharts';

declare var require: any;
var Highcharts = require('highcharts/highmaps.js');
var USA = require('@highcharts/map-collection/countries/us/us-all.geo.json');

@Component({
	selector: 'app-advisor-view-optimised-recommentaions',
	templateUrl: './advisor-view-optimised-recommentaions.component.html',
	styleUrls: ['./advisor-view-optimised-recommentaions.component.scss']
})
export class AdvisorViewOptimisedRecommentaionsComponent implements OnInit {
	graphSlideConfig = {
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: false,
		arrows: true,
	};

	updateFlag = false;
	Highcharts: typeof Highcharts = Highcharts;
	chartConstructor = 'mapChart';
	chartOptions: Highcharts.Options = {
		chart: {
			map: USA,
		},
		exporting: {
			enabled: false,
		},
		title: {
			text: '',
		},
		subtitle: {
			text: '<a href="http://code.highcharts.com/mapdata/countries/us/us-all.js"></a>',
		},
		mapNavigation: {
			enabled: true,
			buttonOptions: {
				alignTo: 'spacingBox',
			},
		},
		legend: {
			enabled: true,
		},
		colorAxis: {
			min: 0,
		},
		series: [
			{
				type: 'map',
				states: {
					hover: {
						color: '#BADA55',
					},
				},
				dataLabels: {
					enabled: true,
					format: '{point.value}',
				},
				allAreas: false,
				data: [],
			},
		],
	};

	user_details: any;

	@Input() recommendation_filter: any;
	@Input() page_type: any; // Individual (In Executive Module to show Individual Advisor Details)
	@Input() advisor_details: any;

	@Output() stateChanged = new EventEmitter<any>();

	constructor(
		private router: Router,
		public commonService: CommonService,
		private storageService: StorageService,
		private spinner: NgxSpinnerService,
		private dialog: MatDialog,
	) {}

	ngOnInit(): void {
		this.spinner.show();
		this.user_details = this.storageService.get('user_details');


		if (this.recommendation_filter) {
			this.recommendation_id = this.recommendation_filter;
			this.recommendation_name = this.recommendation_filter;

			if (this.recommendation_id == "Delegate AFA") {
				this.recommendation_id = "Delegate Junior Advisor";
			}

		} else{
			this.recommendation_id = "All";
		}

		this.getPageData();

		this.getAFA();

		// this.getadvisors();
		//   this.getRegions();
	}

	show_page_graphs: boolean = false;
	createGraphs() {
		if (this.show_page_graphs == true) {
			// this.getPageData();
			setTimeout(() => {
				this.createProductsClientsGraph();
				// this.createRecommendationClientsGraph();

				this.createAUMGraph();
				if (this.recommendation_filter == 'Increase Focus') {
					this.createClientTypeGraph();
				}

				this.createExistingCustomerGraph();
				this.createAgeClientsGraph();
				this.createAssignmentsClientGraph();
				// this.getLeadsRegionGraph();

				// this.getClientsData();
			}, 100);
		}
	}

	selected_region = [];
	region_lists: any = [];
	getRegions() {
		this.commonService.getData('/region?no_page=true/').subscribe(
			(res: any) => {
				this.region_lists = res;
				if (this.region_lists.length > 0) {
					for (let index = 0; index < this.region_lists.length; index++) {
						this.selected_region.push(this.region_lists[index].id);
					}
				}
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	afa_list: any = [];
	getAFA() {
		let route: any = "";

		if (this.page_type == "Individual") {
			route = '/getadvisorafas/?advisor_id=' + this.advisor_details.id;
		} else {
			route = '/getadvisorafas/';
		}
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.afa_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	advisors_data: any = [];
	selected_advisor_segment: any = [73, 44, 43, 74, 999, 42];
	getadvisors() {
		// this.page_loaded = false;
		// let route =
		//   '/advisorclientcharts/?start_date=' +
		//   this.start_date +
		//   '&end_date=' +
		//   this.end_date +
		//   '&type=ai-advisor-assistant';

		// if (this.selected_region.length > 0) {
		//   route = route + '&region=' + this.selected_region;
		// }

		// if (this.selected_advisor_segment.length > 0) {
		//   route = route + '&segment=' + this.selected_advisor_segment;
		// }

		// this.commonService.getData(route).subscribe(
		//   (res: any) => {
		//     this.page_loaded = true;
		//     this.advisors_data = res['data'];
		//     setTimeout(() => {
		//       this.getClientsData();
		//     }, 100);
		//   },
		//   (err) => {
		//     this.commonService.showToast('error', err.error);
		//     this.page_loaded = true;
		//   },
		// );
	}

	page_loaded: boolean = false;
	page_data: any;
	getPageData() {
		this.page_loaded = false;
		let route: any = "";

		if (this.page_type == "Individual") {
			route = '/advisorcharts/' + this.recommendation_id + "/?advisor_id=" + this.advisor_details.id;
		} else {
			route = '/advisorcharts/'+this.recommendation_id;
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.page_data = res;
				if (this.show_page_graphs == true) {
					setTimeout(() => {
						this.createProductsClientsGraph();
						// this.createRecommendationClientsGraph();

						this.createAUMGraph();

						if (this.recommendation_filter == 'Increase Focus') {
							this.createClientTypeGraph();
						}

						this.createExistingCustomerGraph();
						this.createAgeClientsGraph();
						this.createAssignmentsClientGraph();
						// this.getLeadsRegionGraph();
					}, 200);
				}
				// this.createGraphs();
				this.getClientsData();
				this.page_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
				this.page_loaded = true;
			},
		);
	}

	toggleGraphs() {
		if (this.show_page_graphs == true) {
			this.getPageData();
		}
	}

	existing_customer_year: any = '';
	existing_customer_type: any = '';
	createExistingCustomerGraph() {
		let $this = this;
		let graphData = [];
		for (
			let index = 0;
			index < $this.page_data['trends_existing_clients']['labels'].length;
			index++
		) {
			graphData.push({
				name: $this.page_data['trends_existing_clients']['labels'][index],
				data: $this.page_data['trends_existing_clients']['y-axis'][index],
			});
		}
		var options = {
			colors: ['#5EDEC7', '#1B82EC', '#FFE5A3'],
			series: graphData,
			chart: {
				type: 'bar',
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							year: $this.page_data['trends_existing_clients']['x-axis'][
								config.dataPointIndex
							],
							name: $this.page_data['trends_existing_clients']['x-axis'][
								config.dataPointIndex
							],
						};
						$this.existing_customer_year = $this.existing_customer_year == details.year ? '' : details.year;
						$this.current_pagination_page = 1;
						$this.getClientsData();
					},
				},
				// events: {
				//   dataPointSelection: function (event, chartContext, config) {\
				//     const details = {
				//       year: $this.page_data["trends_existing_clients"]["x-axis"][config.dataPointIndex],
				//       type: $this.page_data["trends_existing_clients"]["labels"][config.seriesIndex],
				//     };
				//     $this.existing_customer_year = $this.existing_customer_year == details.year ? "" : details.year;
				//     $this.existing_customer_type = $this.existing_customer_type == details.type ? "" : details.type;
				//     $this.current_pagination_page = 1;
				//     $this.getClientsData();
				//   }
				// },
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 230,
				stacked: true,
				// stackType: '100%'
			},
			plotOptions: {
				bar: {
					horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(
						document.getElementById('existing-clients-graph').clientWidth,
						$this.page_data['trends_existing_clients']['x-axis'].length,
						40,
					),
					endingShape: 'rounded',
				},
			},
			xaxis: {
				categories: $this.page_data['trends_existing_clients']['x-axis'],
			},
			fill: {
				opacity: 1,
			},
			legend: {
				position: 'bottom',
				offsetX: -10,
				offsetY: 0,
			},
		};

		var chart = new ApexCharts(
			document.querySelector('#existing-clients-graph'),
			options,
		);
		chart.render();
	}

	product_id: any = '';
	product_name: any = '';
	createProductsClientsGraph() {
		let $this = this;
		var options = {
			// colors: "#D3D3D3",
			series: [
				{
					name: '',
					data: $this.page_data['leads_by_products']['y-axis'],
				},
			],
			chart: {
				type: 'bar',
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							id: $this.page_data['leads_by_products']['ids'][
								config.dataPointIndex
							],
							name: $this.page_data['leads_by_products']['x-axis'][
								config.dataPointIndex
							],
						};
						$this.product_id = $this.product_id == details.id ? '' : details.id;
						$this.product_name =
						$this.product_name == details.name ? '' : details.name;
						$this.current_pagination_page = 1;
						$this.getClientsData();
					},
				},
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 230,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
					horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(
						document.getElementById('products-clients-graph').clientWidth,
						$this.page_data['leads_by_products']['x-axis'].length,
						5,
					),
					endingShape: 'rounded',
				},
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				// categories: $this.page_data['leads_by_products']['x-axis'],
				categories: $this.page_data['leads_by_products']['code'],
				title: {
					text: '',
				},
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
			// tooltip: {
			// 	y: {
			// 	formatter: function (val) {
			// 		return val;
			// 	},
			// 	},
			// },
			tooltip: {
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					return ('<div style="padding:8px">' +
						'<p>' + "Product" + ": " + $this.page_data['leads_by_products']['x-axis'][dataPointIndex] +
						'</p>' +
						'<p>' + "Count" + ": " + $this.page_data['leads_by_products']['y-axis'][dataPointIndex] +
						'</p>' +
						'</div>')
					}
				}
			};

			var chart = new ApexCharts(
				document.querySelector('#products-clients-graph'),
				options,
			);
			chart.render();
		}

		recommendation_id: any = '';
		recommendation_name: any = '';
		createRecommendationClientsGraph() {
			let $this = this;
			var options = {
				// colors: "#D3D3D3",
				series: [
					{
						name: '',
						data: $this.page_data['clients_by_recommendation']['y-axis'],
					},
				],
				chart: {
					type: 'bar',
					events: {
						dataPointSelection: function (event, chartContext, config) {
							const details = {
								id: $this.page_data['clients_by_recommendation']['x-axis'][
									config.dataPointIndex
								],
								name: $this.page_data['clients_by_recommendation']['x-axis'][
									config.dataPointIndex
								],
							};
							$this.recommendation_id = $this.recommendation_id == details.id ? '' : details.id;
							$this.recommendation_name =
							$this.recommendation_name == details.name ? '' : details.name;
							$this.current_pagination_page = 1;
							$this.getClientsData();
						},
					},
					toolbar: {
						show: false,
					},
					zoom: {
						enabled: false,
					},
					height: 230,
				},
				noData: {
					text: 'No Data Available',
					align: 'center',
					verticalAlign: 'middle',
					offsetX: 0,
					offsetY: 0,
					style: {
						color: '#006AFF',
						fontSize: '24px',
						fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
					},
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: $this.commonService.getBarGraphPercentWidth(
							document.getElementById('recommendation-clients-graph').clientWidth,
							$this.page_data['clients_by_recommendation']['x-axis'].length,
							30,
						),
						endingShape: 'rounded',
					},
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					show: true,
					width: 0,
					colors: ['transparent'],
				},
				xaxis: {
					categories: $this.page_data['clients_by_recommendation']['x-axis'],
					title: {
						text: '',
					},
					crosshairs: {
						show: false,
					},
				},
				yaxis: {
					title: {
						text: '',
					},
				},
				fill: {
					opacity: 1,
				},
				tooltip: {
					y: {
						formatter: function (val) {
							return val;
						},
					},
				},
			};

			var chart = new ApexCharts(
				document.querySelector('#recommendation-clients-graph'),
				options,
			);
			chart.render();
		}

		age_group_id: any = '';
		age_group_name: any = '';
		createAgeClientsGraph() {
			let $this = this;
			var options = {
				// colors: "#D3D3D3",
				series: [
					{
						name: '',
						data: $this.page_data['leads_by_ages']['y-axis'],
					},
				],
				chart: {
					type: 'bar',
					events: {
						dataPointSelection: function (event, chartContext, config) {
							const details = {
								id: $this.page_data['leads_by_ages']['x-axis'][
									config.dataPointIndex
								],
								name: $this.page_data['leads_by_ages']['x-axis'][
									config.dataPointIndex
								],
							};
							$this.age_group_id =
							$this.age_group_id == details.id ? '' : details.id;
							$this.age_group_name =
							$this.age_group_name == details.name ? '' : details.name;
							$this.current_pagination_page = 1;
							$this.getClientsData();
						},
					},
					toolbar: {
						show: false,
					},
					zoom: {
						enabled: false,
					},
					height: 230,
				},
				noData: {
					text: 'No Data Available',
					align: 'center',
					verticalAlign: 'middle',
					offsetX: 0,
					offsetY: 0,
					style: {
						color: '#006AFF',
						fontSize: '24px',
						fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
					},
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: $this.commonService.getBarGraphPercentWidth(
							document.getElementById('age-clients-graph').clientWidth,
							$this.page_data['leads_by_ages']['x-axis'].length,
							30,
						),
						endingShape: 'rounded',
					},
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					show: true,
					width: 0,
					colors: ['transparent'],
				},
				xaxis: {
					categories: $this.page_data['leads_by_ages']['x-axis'],
					title: {
						text: '',
					},
					crosshairs: {
						show: false,
					},
				},
				yaxis: {
					title: {
						text: '',
					},
				},
				fill: {
					opacity: 1,
				},
				tooltip: {
					y: {
						formatter: function (val) {
							return val;
						},
					},
				},
			};

			var chart = new ApexCharts(
				document.querySelector('#age-clients-graph'),
				options,
			);
			chart.render();
		}

		assignment_id: any = '';
		assignment_name: any = '';
		createAssignmentsClientGraph() {
			let $this = this;
			var options = {
				// colors: "#D3D3D3",
				series: [
					{
						name: '',
						data: $this.page_data['clients_by_assignment']['y-axis'],
					},
				],
				chart: {
					type: 'bar',
					events: {
						dataPointSelection: function (event, chartContext, config) {
							const details = {
								id: $this.page_data['clients_by_assignment']['x-axis'][
									config.dataPointIndex
								],
								name: $this.page_data['clients_by_assignment']['x-axis'][
									config.dataPointIndex
								],
							};
							$this.assignment_id =
							$this.assignment_id == details.id ? '' : details.id;
							$this.assignment_name =
							$this.assignment_name == details.name ? '' : details.name;
							$this.current_pagination_page = 1;
							$this.getClientsData();
						},
					},
					toolbar: {
						show: false,
					},
					zoom: {
						enabled: false,
					},
					height: 230,
				},
				noData: {
					text: 'No Data Available',
					align: 'center',
					verticalAlign: 'middle',
					offsetX: 0,
					offsetY: 0,
					style: {
						color: '#006AFF',
						fontSize: '24px',
						fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
					},
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: $this.commonService.getBarGraphPercentWidth(
							document.getElementById('assignment-graph').clientWidth,
							$this.page_data['clients_by_assignment']['x-axis'].length,
							30,
						),
						endingShape: 'rounded',
					},
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					show: true,
					width: 0,
					colors: ['transparent'],
				},
				xaxis: {
					categories: $this.page_data['clients_by_assignment']['x-axis'],
					title: {
						text: '',
					},
					crosshairs: {
						show: false,
					},
				},
				yaxis: {
					title: {
						text: '',
					},
				},
				fill: {
					opacity: 1,
				},
				tooltip: {
					y: {
						formatter: function (val) {
							return val;
						},
					},
				},
			};

			var chart = new ApexCharts(
				document.querySelector('#assignment-graph'),
				options,
			);
			chart.render();
		}

		getLeadsRegionGraph() {
			this.chartOptions.series[0] = {
				type: 'map',
				name: '',
				states: {
					hover: {
						color: '#BADA55',
					},
				},
				dataLabels: {
					enabled: true,
					format: '{point.properties.postal-code}',
				},
				allAreas: false,
				data: this.page_data['client_by_region'],
			};
			this.updateFlag = true;
		}

		aum_name: any = '';
		aum_min_id: any = '';
		aum_max_id: any = '';
		createAUMGraph() {
			let $this = this;
			var options = {
				// colors: "#D3D3D3",
				series: [
					{
						name: '',
						data: $this.page_data['clients_by_aum']['y-axis'],
					},
				],
				chart: {
					type: 'bar',
					events: {
						dataPointSelection: function (event, chartContext, config) {
							const details = {
								id: $this.page_data['clients_by_aum']['ids'][
									config.dataPointIndex
								],
								name: $this.page_data['clients_by_aum']['x-axis'][
									config.dataPointIndex
								],
							};
							const value = details.id.split('-');
							$this.aum_min_id = $this.aum_min_id == value[0] ? '' : value[0];
							$this.aum_max_id = $this.aum_max_id == value[1] ? '' : value[1];
							$this.aum_name = $this.aum_name == details.name ? '' : details.name;
							$this.current_pagination_page = 1;
							$this.getClientsData();
						},
					},
					toolbar: {
						show: false,
					},
					zoom: {
						enabled: false,
					},
					height: 230,
				},
				noData: {
					text: 'No Data Available',
					align: 'center',
					verticalAlign: 'middle',
					offsetX: 0,
					offsetY: 0,
					style: {
						color: '#006AFF',
						fontSize: '24px',
						fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
					},
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: $this.commonService.getBarGraphPercentWidth(
							document.getElementById('aum-graph').clientWidth,
							$this.page_data['clients_by_aum']['x-axis'].length,
							20,
						),
						endingShape: 'rounded',
					},
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					show: true,
					width: 0,
					colors: ['transparent'],
				},
				xaxis: {
					categories: $this.page_data['clients_by_aum']['x-axis'],
					title: {
						// text: 'Value'
					},
					crosshairs: {
						show: false,
					},
				},
				yaxis: {
					title: {
						text: 'Count',
					},
				},
				fill: {
					opacity: 1,
				},
				// tooltip: {
				//   custom: function({series, seriesIndex, dataPointIndex, w}) {
				//     var data = $this.page_data["clients_by_time"]["tooltip"][dataPointIndex];
				//     var count = $this.page_data["clients_by_time"]["y-axis"][dataPointIndex];
				//     data = 'Predicted AUM: $' + data.toLocaleString("en-US") + "<br>";
				//     count = 'Count :' + count;

				//     return  data + count;
				//   },
				//   fixed: {
				//     enabled: true,
				//     position: "topRight"
				//   }
				// }
			};

			var chart = new ApexCharts(document.querySelector('#aum-graph'), options);
			chart.render();
		}

		clients_by_type_name: any = '';
		clients_by_type_id: any = '';
		createClientTypeGraph() {
			let $this = this;

			const options = {
				colors: $this.page_data["clients_by_increase_focus"]['colors'],
				series: $this.page_data["clients_by_increase_focus"]['data'],
				chart: {
					// type: 'bar',
					type: 'donut',
					events: {
						dataPointSelection: function (event, chartContext, config) {
							const details = {
								id: $this.page_data['clients_by_increase_focus']['labels'][config.dataPointIndex],
								name: $this.page_data['clients_by_increase_focus']['labels'][config.dataPointIndex],
							};
							$this.clients_by_type_id = $this.clients_by_type_id == details.id ? '' : details.id;
							$this.clients_by_type_name = $this.clients_by_type_name == details.name ? '' : details.name;
							$this.current_pagination_page = 1;
							$this.getClientsData();
						},
					},
					toolbar: {
						show: false,
					},
					zoom: {
						enabled: false,
					},
					height: 280,
				},
				noData: {
					text: 'No Data Available',
					align: 'center',
					verticalAlign: 'middle',
					offsetX: 0,
					offsetY: 0,
					style: {
						color: '#006AFF',
						fontSize: '24px',
						fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
					},
				},
				plotOptions: {
					pie: {
						startAngle: 0
					}
				},
				dataLabels: {
					enabled: false,
				},
				labels: $this.page_data["clients_by_increase_focus"]['labels'],
				legend: {
					position: 'bottom',
					enabled: false,
				},
				yaxis: {
					title: {
						text: '',
					},
				},
				fill: {
					opacity: 1,
				},
			};

			var chart = new ApexCharts(
				document.querySelector('#clients-type-graph'),
				options,
			);
			chart.render();

		}

		navigateToPage(url) {
			this.router.navigate([url]);
		}

		abbreviateNumber(value) {
			let fixed = 1;
			let num = value;
			if (num === null) {
				return null;
			}
			if (num === 0) {
				return '0';
			}
			fixed = !fixed || fixed < 0 ? 0 : fixed;
			var b = num.toPrecision(2).split('e'),
			k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
			c =
			k < 1
			? num.toFixed(0 + fixed)
			: (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
			d = c < 0 ? c : Math.abs(c),
			e = d + ['', 'K', 'M', 'B', 'T'][k];
			return e;

		}

		calculateWidth(data, value) {
			let total = 0;
			for (let index = 0; index < data.length; index++) {
				const count = parseInt(data[index]['count']);
				total = total + count;
			}
			const width = (value / total) * 100 + '%';
			return width;
		}

		search_key: any = '';

		current_pagination_page = 1;
		total_pagination_records = 0;
		pagination_records_limit: any = 10;

		selected_alphabet = '';
		alphabets_array = [
			'A',
			'B',
			'C',
			'D',
			'E',
			'F',
			'G',
			'H',
			'I',
			'J',
			'K',
			'L',
			'M',
			'N',
			'O',
			'P',
			'Q',
			'R',
			'S',
			'T',
			'U',
			'V',
			'W',
			'X',
			'Y',
			'Z',
		];
		show_search: boolean = false;
		table_columns: any = [
			{
				name: 'Client ID',
				key: 'client_id',
				checked: true,
			},
			{
				name: 'Type',
				key: 'type',
				checked: true,
			},
			{
				name: 'AUM',
				key: 'total_aum',
				checked: true,
			},
			{
				name: 'First Name',
				key: 'first_name',
				checked: true,
			},
			{
				name: 'Last Name',
				key: 'last_name',
				checked: true,
			},
			{
				name: 'No.of Products',
				key: 'no_of_products',
				checked: true,
			},
			{
				name: 'Email',
				key: 'email',
				checked: true,
			},
			{
				name: 'Phone Number',
				key: 'telephone_number',
				checked: true,
			},
			{
				name: 'Client Status',
				key: 'status',
				checked: true,
			},
			{
				name: 'Actions',
				key: 'actions',
				checked: true,
			},
		];
		table_data: any = [];
		selected_table_data: any = [];
		table_data_loaded: boolean = false;
		show_toggle_columns: boolean = false;
		getClientsData() {
			this.table_data_loaded = false;
			const search_key = this.search_key;

			const user_details = this.storageService.get('user_details');

			// let route: any = '/client?records_per_page=' + this.pagination_records_limit + '&search=' + this.search_key + '&alphabet=' + this.selected_alphabet + '&page=' + this.current_pagination_page + '&advisor=' + this.user_details.id + '&total_clients=true&value_analysis=true';
			let route: any = '/client?records_per_page=' + this.pagination_records_limit + '&search=' + this.search_key + '&alphabet=' + this.selected_alphabet + '&page=' + this.current_pagination_page + '&total_clients=true&value_analysis=true';

			if (this.product_id != '') {
				route = route + '&clients_by_product=' + this.product_id;
			}

			if (this.existing_customer_year != '') {
				route = route + '&clients_by_year=' + this.existing_customer_year;
			}

			if (this.age_group_id != '') {
				route = route + '&clients_by_agegroup=' + this.age_group_id;
			}

			if (this.assignment_id != '') {
				route = route + '&clients_by_assignment=' + this.assignment_id;
			}

			if (this.recommendation_id != '') {
				route = route + '&clients_by_recommendation=' + this.recommendation_id ;
			}

			if (this.aum_min_id != '') {
				route = route + '&client_aum_min=' + this.aum_min_id;
			}

			if (this.aum_max_id != '') {
				route = route + '&client_aum_max=' + this.aum_max_id;
			}

			if (this.clients_by_type_id != '') {
				route = route + '&clients_by_increase_focus=' + this.clients_by_type_id ;
			}

			if (this.page_type == "Individual") {
				route = route + '&advisor=' + this.advisor_details.id;
			} else {
				route = route + '&advisor=' + this.user_details.id;
			}

			this.commonService.getData(route).subscribe(
				(res: any) => {
					this.table_columns = res['results']['columns'];
					if (this.table_columns.length > 0) {
						for (let index = 0; index < 9; index++) {
							this.table_columns[index].checked = true;
						}
					}
					this.table_data = res['results']['data'];
					this.current_pagination_page = res.page_number;
					this.total_pagination_records = res.total_no_of_records;
					this.table_data_loaded = true;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}

		pageChanged(event) {
			this.current_pagination_page = event;
			this.pagination_records_limit = this.pagination_records_limit;
			this.getClientsData();
		}

		getKey(data, column) {
			const key = column['key'];
			return data[key];
		}

		is_selected: boolean = false;
		selectAll(event) {
			if (event.checked == true) {
				this.selected_table_data = JSON.parse(JSON.stringify(this.table_data));
				this.is_selected = true;
			} else {
				this.selected_table_data = [];
				this.is_selected = false;
			}
		}

		checkIndividualSelection(data) {
			const index = this.selected_table_data.findIndex(
				(obj) => obj.id == data.id,
			);
			if (index != -1) {
				return true;
			} else {
				return false;
			}
		}

		selectIndividual(event, data) {
			const index = this.selected_table_data.findIndex(
				(obj) => obj.id == data.id,
			);
			if (index != -1) {
				if (event.checked == true) {
					this.selected_table_data.splice(index, 0, data);
				} else {
					this.selected_table_data.splice(index, 1);
				}
			} else {
				this.selected_table_data.splice(index, 0, data);
			}
			if (this.table_data.length == this.selected_table_data.length) {
				this.is_selected = true;
			} else {
				this.is_selected = false;
			}
		}

		@ViewChild('clientDataModal') clientDataModal: TemplateRef<any>;
		private clientDataModalRef: MatDialogRef<TemplateRef<any>>;

		selected_client: any;
		selected_modal_client_loader: boolean = false;;
		openClientDataModal(data) {
			this.selected_client = JSON.parse(JSON.stringify(data));
			this.selected_modal_client_loader = true;
			this.clientDataModalRef = this.dialog.open(this.clientDataModal, { disableClose: true });
			this.clientDataModalRef.afterClosed().subscribe((result) => {
				this.closeClientDataModal();
			});

			this.commonService.getData('/customerdetails/?id=' + this.selected_client.id).subscribe(
				(res: any) => {
					this.selected_client = res["data"];
					this.selected_modal_client_loader = false;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}

		closeClientDataModal() {
			this.selected_client = {};
			this.clientDataModalRef.close();
		}

		@ViewChild('assignAIAdvisorAssistantModal')
		assignAIAdvisorAssistantModal: TemplateRef<any>;
		private assignAIAdvisorAssistantModalRef: MatDialogRef<TemplateRef<any>>;

		openAssignAIAdvisorAssistantModal() {
			this.assignAIAdvisorAssistantModalRef = this.dialog.open(
				this.assignAIAdvisorAssistantModal, { disableClose: true }
			);
			this.assignAIAdvisorAssistantModalRef.afterClosed().subscribe((result) => {
				this.closeAssignAIAdvisorAssistantModal();
			});
		}

		closeAssignAIAdvisorAssistantModal() {
			this.ai_advisor_assistant = '';
			this.ai_advisor_assistant_error = false;
			this.assignAIAdvisorAssistantModalRef.close();
		}

		moveToAssignAIAdvisorAssistant() {
			if (this.selected_table_data.length > 0) {
				this.openAssignAIAdvisorAssistantModal();
			} else {
				this.commonService.showToast(
					'error',
					'Please Select minimum one Client to update recommendation',
				);
			}
		}


		ai_advisor_assistant: any = '';
		ai_advisor_assistant_error: any = false;
		assigning_ai_advisor_assistant_loader: boolean = false;
		assignAIAdvisorAssistant() {
			if (this.ai_advisor_assistant != "" && this.ai_advisor_assistant != null) {
				this.ai_advisor_assistant_error = false;
			} else {
				this.ai_advisor_assistant_error = true;
			}

			if (this.ai_advisor_assistant_error == false) {
				this.assigning_ai_advisor_assistant_loader = true;
				let payload: any = {
					recommendation: this.ai_advisor_assistant,
					clients: [],
				};

				if (this.page_type == "Individual") {
					payload.advisor_id = this.advisor_details.id;
				}

				for (let index = 0; index < this.selected_table_data.length; index++) {
					payload.clients.push(this.selected_table_data[index].id);
				}
				this.commonService.postData('/updaterecommendation/', payload).subscribe(
					(res: any) => {
						this.selected_table_data = [];
						this.getPageData();

						this.commonService.showToast('success', 'Recommendation Updated Successfully.');

						this.dataChanged.emit("Updated");


						this.closeAssignAIAdvisorAssistantModal();
						this.assigning_ai_advisor_assistant_loader = false;
					},
					(err) => {
						this.assigning_ai_advisor_assistant_loader = false;
						this.commonService.showToast('error', err.error);
					},
				);
			}
		}

		saveIndiviualRecommendation(data) {
			let payload: any = {
				recommendation: data.recommendation,
				clients: [data.id],
			};
			this.commonService.postData('/updaterecommendation/', payload).subscribe(
				(res: any) => {
					this.selected_table_data = [];
					this.dataChanged.emit("Updated");
					this.commonService.showToast('success', 'Recommendation Updated Successfully.');
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}

		back() {
			this.stateChanged.emit('Summary');
		}


		@Output() countChanged = new EventEmitter<any>();



		show_user_profile: boolean = false;
		user_profile_data: any;
		showUserProfile(data) {
			this.user_profile_data = JSON.parse(JSON.stringify(data));
			this.show_user_profile = true;
		}

		profileClosed(event) {
			this.user_profile_data = {};
			this.show_user_profile = false;
		}

		@Input() show_recommendations_explanation: any;

		@Output() dataChanged = new EventEmitter<any>();

		@ViewChild('assign')
		assign: TemplateRef<any>;
		private assignRef: MatDialogRef<TemplateRef<any>>;

		openassign() {
			this.assignRef = this.dialog.open(
				this.assign, { disableClose: true }
			);
			this.assignRef.afterClosed().subscribe((result) => {
				this.closeassign();
			});
		}

		closeassign() {
			this.ai_advisor_assistant = '';
			this.ai_advisor_assistant_error = false;
			this.assignRef.close();
		}

		@ViewChild('delegateMAGIModal') delegateMAGIModal: TemplateRef<any>;
		private delegateMAGIModalRef: MatDialogRef<TemplateRef<any>>;

		openDelegateMAGIModal() {
			this.delegateMAGIModalRef = this.dialog.open(this.delegateMAGIModal, { disableClose: true });
			this.delegateMAGIModalRef.afterClosed().subscribe((result) => {
				this.closeDelegateMAGIModal();
			});
		}

		closeDelegateMAGIModal() {
			this.delegateMAGIModalRef.close();
			this.agi_assignment = true;
			this.agi_assignment_error = false;
		}

		moveToDelagateMAGI() {
			if (this.selected_table_data.length > 0) {
				this.openDelegateMAGIModal();
			} else {
				this.commonService.showToast('error', 'Please Select minimum one Client to Assign MAGI');
			}
		}

		agi_assignment: any = true;
		agi_assignment_error: boolean = false;
		agi_assignment_loader: boolean = false;

		assignMAGI() {
			if (this.agi_assignment != "" && this.agi_assignment != null) {
				this.agi_assignment_error = false;
			} else {
				this.agi_assignment_error = true;
			}


			if (this.agi_assignment_error == false) {
				this.agi_assignment_loader = true;

				let payload: any = {
					agi_assignment: true,
					clients: [],
					// delegate_type: "MAGI",
					delegate_type: "AGI",
				};

				if (this.page_type == "Individual") {
					payload.advisor_id = this.advisor_details.id;
				}

				for (let index = 0; index < this.selected_table_data.length; index++) {
					payload.clients.push(this.selected_table_data[index].id);
				}
				this.commonService.postData('/delegateclient/', payload).subscribe(
					(res: any) => {
						this.selected_table_data = [];

						this.getPageData();

						this.commonService.showToast('success', 'MAGI Assigned Successfully.');

						this.dataChanged.emit("Updated");


						this.closeDelegateMAGIModal();

						this.agi_assignment_loader = false;
					},
					(err) => {
						this.agi_assignment_loader = false;
						this.commonService.showToast('error', err.error);
					},
				);
			}

		}

		saveIndiviualAssignMAGI(data) {
			let payload: any = {
				agi_assignment: data.assigned_agi,
				clients: [data.id],
				// delegate_type: "MAGI",
				delegate_type: "AGI",
			};

			this.commonService.postData('/delegateclient/', payload).subscribe(
				(res: any) => {
					this.selected_table_data = [];
					this.dataChanged.emit("Updated");
					this.commonService.showToast('success', 'MAGI Assigned Successfully.');
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}

		@ViewChild('delegateAFAModal') delegateAFAModal: TemplateRef<any>;
		private delegateAFAModalRef: MatDialogRef<TemplateRef<any>>;

		openDelegateAFAModal() {
			this.delegateAFAModalRef = this.dialog.open(this.delegateAFAModal, { disableClose: true });
			this.delegateAFAModalRef.afterClosed().subscribe((result) => {
				this.closeDelegateAFAModal();
			});
		}

		closeDelegateAFAModal() {
			this.delegateAFAModalRef.close();
			this.junior_advisor = "";
			this.junior_advisor_assignment_error = false;
		}

		moveToDelagateAFA() {
			if (this.selected_table_data.length > 0) {
				this.openDelegateAFAModal();
			} else {
				this.commonService.showToast(
					'error',
					'Please Select minimum one Client to Assign Junior Advisor',
				);
			}
		}

		junior_advisor: any = "";
		junior_advisor_assignment_error: boolean = false;
		junior_advisor_assignment_loader: boolean = false;

		assignAFA() {
			// if (this.junior_advisor != "" && this.junior_advisor != null) {
			// 	this.junior_advisor_assignment_error = false;
			// } else {
			// 	this.junior_advisor_assignment_error = true;
			// }


			if (this.junior_advisor_assignment_error == false) {
				this.junior_advisor_assignment_loader = true;

				let payload: any = {
					afa_id: this.junior_advisor,
					clients: [],
					delegate_type: "Junior Advisor",
				};

				if (this.page_type == "Individual") {
					payload.advisor_id = this.advisor_details.id;
				}

				for (let index = 0; index < this.selected_table_data.length; index++) {
					payload.clients.push(this.selected_table_data[index].id);
				}
				this.commonService.postData('/delegateclient/', payload).subscribe(
					(res: any) => {
						this.selected_table_data = [];

						this.getPageData();

						this.commonService.showToast('success', 'Junior Advisor Assigned Successfully.');

						this.dataChanged.emit("Updated");


						this.closeDelegateAFAModal();

						this.junior_advisor_assignment_loader = false;
					},
					(err) => {
						this.junior_advisor_assignment_loader = false;
						this.commonService.showToast('error', err.error);
					},
				);
			}

		}

		saveIndiviualAssignAFA(data) {
			let payload: any = {
				afa_id: data.assigned_junior_advisor,
				clients: [data.id],
				delegate_type: "Junior Advisor",
			};
			this.commonService.postData('/delegateclient/', payload).subscribe(
				(res: any) => {
					this.selected_table_data = [];
					this.dataChanged.emit("Updated");
					this.commonService.showToast('success', 'Junior Advisor Assigned Successfully.');
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}

	}
